document.addEventListener('DOMContentLoaded', function () {
  
  /* ── Reading Progress Bar ── */
  var progressBar = document.getElementById('ArticleProgressBar');
  if (progressBar) {
    window.addEventListener('scroll', function () {
      var scrollTop = window.scrollY || document.documentElement.scrollTop;
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight > 0) {
        var progress = (scrollTop / docHeight) * 100;
        progressBar.style.width = progress + '%';
      }
    });
  }

  /* ── FAQ Accordion Toggle ── */
  var accordionTriggers = document.querySelectorAll('.article-faq-accordion__trigger');
  
  accordionTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var isExpanded = trigger.getAttribute('aria-expanded') === 'true';
      var content = trigger.nextElementSibling;

      // Close other accordions in the same article container if needed (optional)
      // Here we just toggle the clicked accordion independently to allow multiple open questions
      if (isExpanded) {
        trigger.setAttribute('aria-expanded', 'false');
        content.style.maxHeight = '0px';
      } else {
        trigger.setAttribute('aria-expanded', 'true');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });

  // Handle accordion resize to update dynamic scroll height if needed
  window.addEventListener('resize', function () {
    var expandedContents = document.querySelectorAll('.article-faq-accordion__trigger[aria-expanded="true"] + .article-faq-accordion__content');
    expandedContents.forEach(function (content) {
      content.style.maxHeight = content.scrollHeight + 'px';
    });
  });

  /* ── Product Card Quick Add to Cart ── */
  var addToCartButtons = document.querySelectorAll('.article-product-card__add-to-cart-btn');

  addToCartButtons.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var variantId = parseInt(btn.dataset.variantId, 10);
      if (!variantId) return;

      var iconCart = btn.querySelector('.icon-cart-bag');
      var iconCheck = btn.querySelector('.icon-checkmark');
      var spinner = btn.querySelector('.article-product-card__spinner');

      // Set to loading state
      btn.disabled = true;
      if (iconCart) iconCart.style.display = 'none';
      if (iconCheck) iconCheck.style.display = 'none';
      if (spinner) spinner.style.display = 'inline-block';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(function (res) {
        if (!res.ok) {
          throw new Error('Network response error adding product to cart.');
        }
        return res.json();
      })
      .then(function (data) {
        // Set to success state
        if (spinner) spinner.style.display = 'none';
        if (iconCheck) iconCheck.style.display = 'inline-block';
        btn.classList.add('success');
        
        // Dispatch theme cart refresh event
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { open: true }
        }));

        setTimeout(function () {
          btn.classList.remove('success');
          btn.disabled = false;
          if (iconCheck) iconCheck.style.display = 'none';
          if (iconCart) iconCart.style.display = 'inline-block';
        }, 2200);
      })
      .catch(function (error) {
        console.error('Error adding to cart:', error);
        if (spinner) spinner.style.display = 'none';
        if (iconCart) iconCart.style.display = 'inline-block';
        btn.disabled = false;
      });
    });
  });

});
